import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AccueilPage from "./pages/AccueilPage";
import ServicesPage from "./pages/ServicesPage";
import CataloguePage from "./pages/CataloguePage";
import RealisationsPage from "./pages/RealisationsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<AccueilPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/catalogue" element={<CataloguePage />} />
          <Route path="/realisations" element={<RealisationsPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
